export enum Endpoints {
    GET_USERS = '/api-db/resources/v2/dashboard/invite/getAllUsers?shopIds=',
    DEACTIVATE_USER = '/api-db/resources/v2/dashboard/invite/deactivateUser/',
    GET_INVITE = '/api-db/resources/v2/dashboard/invite?inviteeId=',
}
